export enum OS {
  Android,
  iOS,
  Other
}
